<div class="tabs-detail-header">
    <div class="title">
        Hyperlinks
        <cerrix-instructions-icon
            [instructionText]="'assetmanagement.hyperlinks.hyperlinksInformation' | transloco"
            [showText]="false"
        ></cerrix-instructions-icon>
    </div>
    @if (canEdit) {
        <cerrix-icon-button
            class="add-hyperlink-button"
            buttonType="secondary"
            secondaryColor="filled-blue"
            buttonSize="big"
            icon="link"
            iconPosition="left"
            [text]="'assetmanagement.hyperlinks.addHyperlinkButton' | transloco"
            (click)="onAddHyperlink()"
        >
        </cerrix-icon-button>
    }
</div>
<div class="hyperlinks">
    @if (this.model.hyperlinks.length !== 0) {
        @for (hyperlink of model.hyperlinks; track $index) {
            <div class="hyperlink-item">
                <a
                    [href]="getHyperlinkHref(hyperlink.hyperlinkUrl)"
                    rel="noopener noreferrer"
                    target="_blank"
                    class="hyperlink-link"
                >
                    <mat-icon class="hyperlink-icon" svgIcon="link-external"></mat-icon>
                    <div class="hyperlink-name">
                        {{ hyperlink.name }}
                    </div>
                    @if (hyperlink.description) {
                        <mat-icon
                            [cerrixHover]="hyperlinkDescriptionCard"
                            class="hyperlink-description-icon"
                            svgIcon="chat"
                        >
                            <ng-template #hyperlinkDescriptionCard>
                                <div class="hyperlink-description-text">
                                    {{ hyperlink.description }}
                                </div>
                            </ng-template>
                        </mat-icon>
                    }
                </a>
                <app-cerrix-kebab-menu
                    [menuItems]="getKebabItems(hyperlink)"
                ></app-cerrix-kebab-menu>
            </div>
        }
    }
</div>

<app-cerrix-add-hyperlink-dialog
    [name]="this.openHyperlinkDialogName"
    [openReason]="this.openHyperlinkDialogReason"
    (cancelDialog)="closeCancel()"
    (confirmDialog)="saveHyperlink($event)"
></app-cerrix-add-hyperlink-dialog>

<cerrix-confirm-dialog
    [name]="confirmRemoveHyperlinkDialogName"
    dataUiid="asset-management-remove-hyperlink-confirm"
    icon="warning"
    [title]="'assetmanagement.hyperlinks.removeHyperlinkDialogTitle' | transloco"
    [description]="'assetmanagement.hyperlinks.removeHyperlinkDialogDescription' | transloco"
    [cancelText]="'assetmanagement.hyperlinks.removeHyperlinkDialogCancelText' | transloco"
    [confirmText]="'assetmanagement.hyperlinks.removeHyperlinkDialogConfirmText' | transloco"
    (cancel)="removeHyperlinkCancel()"
    (confirm)="removeHyperlinkConfirm()"
    [waitingOnResult]="removeHyperlinkLoading"
    [showResultText]="removeHyperlinkLoading"
    class="dialog-remove-hyperlink-confirm"
>
    <div class="dont-ask-me-again-input">
        <input
            type="checkbox"
            name="dontAskMeAgain"
            [checked]="dontAskMeAgainSelected"
            (change)="dontAskMeAgainSelected = $event.target.checked"
        />
        <label for="dontAskMeAgain">{{
            "assetmanagement.hyperlinks.removeHyperlinkDialogDontAskAgain" | transloco
        }}</label>
    </div>
</cerrix-confirm-dialog>
